/* import libraries */
import { Link } from "react-router-dom";

const ClosedMessage = () => {

    return (
        <div className="closedBox">
            <img src="/assets/Chat lock.svg" width="20px" height="35px" alt="support" />
            <p style={{ fontSize: "12px" }}>This ticket is closed.<br/>
            If you have any other issue, please visit our 
            <Link 
                to={"/?token=" + localStorage.getItem('token')} 
                className="font-semibold" 
                style={{ textDecoration: 'none' }}> RydeHELP.</Link></p>
        </div>
    );
}

export default ClosedMessage;